import { arrayOf, node, shape, string, bool, number } from "prop-types";
import { useEffect, useState } from "react";
import cx from "classnames";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";

import StyledLink from "../StyledLink/StyledLink.jsx";
import VideoApiPlayer from "../VideoApiPlayer/VideoApiPlayer.jsx";

const propTypes = {
  index: number,
  hideFeatured: bool,
  promos: arrayOf(
    shape({
      title: string,
      description: node,
      displayTextRight: bool,
      link: string,
      linkTarget: string,
      videoId: string,
      playerType: string,
      placeholderImg: string,
    }).isRequired,
  ).isRequired,
};

const MultiPromoVideoMobile = (props) => {
  const { hideFeatured, promos, index } = props;

  const [renderSwiper, setRenderSwiper] = useState(false);

  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderSwiper(true);
  }, []);

  SwiperCore.use([A11y, Pagination, Navigation]);

  return (
    <div className="multi-promo-video__swiper">
      {renderSwiper && (
        <Swiper
          a11y
          observer={true}
          observeParents={true}
          navigation={
            promos.length > 1
              ? {
                  prevEl: `.related-programs__prev-${index}`,
                  nextEl: `.related-programs__next-${index}`,
                }
              : false
          }
          pagination={{ clickable: true }}
          slidesPerView={1}
          spaceBetween={30}
        >
          {promos.map((promo, index) => (
              <SwiperSlide key={promo.key}>
                <div
                  className={cx("js-multi-promo-video-slide", {
                    "multi-promo-c__featured-promo": !hideFeatured && index === 0,
                    "multi-promo-c__promo": hideFeatured || index > 0,
                  })}
                >
                  <div
                    className={cx({
                      "multi-promo-c__featured-content": !hideFeatured && index === 0,
                      "multi-promo-c__promo-content": hideFeatured || index > 0,
                    })}
                  >
                    {promo.eyebrow && !hideFeatured && (
                      <div
                        className="multi-promo-a__eyebrow"
                        data-aos="border-grow"
                        data-aos-once="true"
                      >
                        {promo.eyebrow}
                      </div>
                    )}
                    <h4
                      className={cx({
                        "multi-promo-c__featured-title": !hideFeatured && index === 0,
                        "multi-promo-c__promo-title": hideFeatured || index > 0,
                        "--top-margin": !hideFeatured && !promo.eyebrow,
                      })}
                    >
                      {promo.link ? (
                        <StyledLink href={promo.link} target={promo.linkTarget}>
                          {promo.title}
                        </StyledLink>
                      ) : (
                        <span>{promo.title}</span>
                      )}
                    </h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: promo.description,
                      }}
                    ></div>
                  </div>

                  <div
                    className={cx({
                      "multi-promo-c__featured-video": !hideFeatured && index === 0,
                      "multi-promo-c__promo-video": hideFeatured || index > 0,
                    })}
                  >
                    <VideoApiPlayer
                      videoId={promo.videoId}
                      playerType={promo.playerType}
                      placeholderImg={promo.placeholderImg}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </div>
  );
};

MultiPromoVideoMobile.propTypes = propTypes;
export default MultiPromoVideoMobile;
